import state from "./ApplicationState";

export function sendGoogle(category: string, action: string, label: string = undefined, value: string = undefined)
{
    let gtag = window['gtag'];

    if (typeof gtag === 'undefined') {
        console.error('Analytics: GTAG is not defined');
    } else {
        label  = typeof label === 'undefined' ? null : label;
        value  = typeof value === 'undefined' ? null : value;

        gtag('event', action, {
            'event_category': category,
            'event_label': label,
            'value': value
        });
    }
}

export function sendYandex(goal: string) {
    let yaCounter = window[state.commonStorage.get('yaCounter')] as any;

    if (typeof yaCounter === 'undefined') {
        console.error('Analytics: yaCounter is not defined');
    } else {
        yaCounter.reachGoal(goal);
    }
}

export function sendComagic(category: string, action: string) {
    let comagic = window['Comagic'] as any;

    if (typeof comagic === 'undefined') {
        console.warn('metrics.js: Comagic is not defined');
    } else {
        comagic.trackEvent(category, action);
    }
}

export function sendCriteoTransaction (id: string) {
    let criteoQueue  = window['criteo_q'] || [];

    criteoQueue.push(
        {event: "setAccount", account: 43898},
        {event: "setEmail", email: ""},
        {event: "setSiteType", type: "d"},
        {
            event: "trackTransaction", id: id, item: [
                {id: "1", price: 1, quantity: 1 }
            ]
        }
    );
}

export function sendAnalyticsByClick(selector: string)
{
    document.querySelectorAll(selector).forEach(node => {
        node.addEventListener('click', () => sendAnalyticsFromDataAttributes(node as HTMLElement));
    });
}

/**
 * Отправка событий для узла item используя data-атрибуты
 * @param item - узел DOM, содержащий следующие атрибуты:
 *      - data-ga-category - обязательный. Содержит название категории события Google Analytics, например 'product'
 *      - data-ga-action   - обязательный. Содержит наименование действия для Google Analytics, например 'Клик по кнопке'
 *      - data-ga-label    - необязательный. Дополнительный параметр-метка, например "Купить"
 */
export function sendAnalyticsFromDataAttributes(item: HTMLElement)
{
    let category = item.dataset.gaCategory;
    let action = item.dataset.gaAction;
    let label = typeof item.dataset.gaLabel === 'undefined' ? null : item.dataset.gaLabel;

    if (category && action) {
        sendGoogle(category, action, label);
    }
}

export function sendGTagRetail(eventType: string, ids: Array<Number|string>, value: Number)
{
    const clientId = 'AW-401117343';

    let gtag = window['gtag'];

    if (typeof gtag === 'undefined') {
        console.error('Analytics: gtag is not defined');
        return;
    }

    let params = {send_to: clientId, items: []};

    ids.forEach(id => {
        params.items.push({id: Number(id), google_business_vertical: 'retail'});
    });

    if (typeof value !== 'undefined' && value > 0) {
        params['value'] = value;
    }

    if (window.location.href.search('ad-debug=y') !== -1) {
        console.log('===== Debug google ads =====');
        console.log('= event type: ' + eventType);
        console.log('= parameters:', params);
        console.log('=====================');
    }

    gtag('event', eventType, params);
}

export function leftMenuAnalytics()
{
    document.querySelectorAll('.menu-catalog__link, .menu-catalog .submenu__item .link').forEach(node => {
        let item = node as HTMLElement;

        item.addEventListener('click', () => {
            sendGoogle('Вертикальное меню', 'Клик', item.getAttribute('href'));
        });

        let delay = null;
        item.addEventListener('mouseout', () => clearTimeout(delay));
        item.addEventListener('mouseover', () => {
            if (item.parentElement.classList.contains('menu-catalog__item_has-popup')) {
                delay = setTimeout(() => sendGoogle('Вертикальное меню', 'Наведение', item.innerText), 1000);
            }
        });
    });
}
